m = require 'mithril'

CommonViews 		= require './CommonViews'
ImportDataPane 		= require './ImportDataPane'
ImportSelectionPane = require './ImportSelectionPane'

ImportPane = {
	controller: (args) ->
		ctrl = @
		ctrl.suppliedGames = m.prop null
		ctrl

	view: (ctrl, args) ->
		games = ctrl.suppliedGames()
		m '.importpane', [
			m ImportDataPane, {onGamesSupplied: ctrl.suppliedGames} if not games?
			m ImportSelectionPane, {onImport: args.onImport, games: ctrl.suppliedGames()} if games?
		]
}

module.exports = ImportPane